import { SvgIcon } from '@mui/material';

export function Explode() {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M8.146 16.146l.707.707-3.5 3.5-.707-.707zM20.353 5.353l-.707-.707-3.5 3.5.707.707zM15 3h-1v3l1 1zm7 8v-1h-4l1 1zM10 22h1v-3l-1-1zm-7-8v1h4l-1-1zm6.69-1.309l-.827-.827a4.23 4.23 0 0 1-1.73.002 3.881 3.881 0 0 1-1.961-1.038l-1-1a4 4 0 1 1 5.656-5.656l1 1a3.967 3.967 0 0 1 1.063 1.937 3.735 3.735 0 0 1 .002 1.784l.796.796A4.986 4.986 0 0 0 13 8a4.98 4.98 0 0 0-.31-1.69 4.966 4.966 0 0 0-1.155-1.845l-1-1a5 5 0 1 0-7.07 7.07l1 1A4.966 4.966 0 0 0 6.31 12.69a4.77 4.77 0 0 0 3.38.001zm10.845.774a4.92 4.92 0 0 0-5.224-1.154l.796.796a3.735 3.735 0 0 1 1.784.002 3.967 3.967 0 0 1 1.937 1.063l1 1a4 4 0 1 1-5.656 5.656l-1-1a3.967 3.967 0 0 1-1.063-1.937 3.695 3.695 0 0 1 0-1.78l-.8-.801a5.05 5.05 0 0 0 1.156 5.225l1 1a5 5 0 1 0 7.07-7.07z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    </SvgIcon>
  );
}
